import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getSettings } from '../services/api';
import { useAuth } from './AuthContext';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();

  const [settings, setSettings] = useState({
    hr_can_see_invoices: true,
    hr_can_see_crm: true,
  });
  const [loadingSettings, setLoadingSettings] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const { data } = await getSettings();
      setSettings(data);
    } catch {
      // keep defaults on error
    } finally {
      setLoadingSettings(false);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchSettings();
    } else {
      setLoadingSettings(false);
    }
  }, [isAuthenticated, fetchSettings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, fetchSettings, loadingSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
